﻿import {JSX, memo} from "react";

export type WizardStepProps = {
	title: string;
	hidden?: boolean;
	children: (props: WizardStepProps) => React.ReactNode;
}

function WizardStep(props: WizardStepProps): JSX.Element {
	return <>{props.children}</>;
}

const MemoizedWizardStep: React.FC<WizardStepProps> = memo(WizardStep);
export default MemoizedWizardStep;
